import type { ConnectorDefinition } from './ConnectorDefinition';
import { composePose, invertPose, type Pose } from './Pose';

/** World pose of a connector of a placed segment. */
export function connectorWorldPose(segmentPose: Pose, connector: ConnectorDefinition): Pose {
  return composePose(segmentPose, connector.transform);
}

/**
 * Computes the world pose of the next segment so that its entry connector
 * coincides exactly (position + heading) with the exit connector of the
 * previous segment:  next = prev ∘ exit ∘ entry⁻¹
 */
export function alignToExit(previousSegmentPose: Pose, exit: ConnectorDefinition, nextEntry: ConnectorDefinition): Pose {
  return composePose(connectorWorldPose(previousSegmentPose, exit), invertPose(nextEntry.transform));
}

export function areConnectorsCompatible(exit: ConnectorDefinition, entry: ConnectorDefinition): boolean {
  return exit.allowedNextProfiles.includes(entry.profile);
}
